import { render, staticRenderFns } from "./DatePicker.vue?vue&type=template&id=f4a850c2&scoped=true"
import script from "./DatePicker.vue?vue&type=script&lang=ts"
export * from "./DatePicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a850c2",
  null
  
)

export default component.exports